"use client" // Error boundaries must be Client Components

import { ErrorLogger_action } from '@/lib/actions/auth.action'
import { cn } from '@/lib/utils'
import { ReactNode, useEffect } from 'react'
import { BiErrorAlt } from 'react-icons/bi'
import { Button } from '../ui/forms/button'
import AnimatedIcon from '../ui/utils/AnimatedIcon'

export default function AdminError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {

    return <>
        <span></span>
        <GenericError
            logToConsole
            error={ error }
            title={ "שגיאה בפאנל" }
            description={ <>
                הדף שניסית לטעון נתקל בשגיאה בצד של השרת!
                <br />
                שגיאה זו לא מתוכננת וסביר ולא צפויה, יש לדווח עליה במידי!
            </> }
            action={ <p className="text-justify [text-align-last:center] max-w-xl text-last">
                אם לדעתך שגיאה זו סודרה - אפשר
                <Button className='ms-2' variant={ "outline" }
                    onClick={
                        // Attempt to recover by trying to re-render the segment
                        () => reset()
                    }
                >
                    לנסות שוב
                </Button>
            </p> } />
    </>
}


export function GenericError({ title, description, action, error, logToConsole = true, small = false, className, helpReport = true }: { helpReport?: boolean, className?: string, logToConsole?: boolean, small?: boolean, title: ReactNode, description: ReactNode, action?: ReactNode, error: Error & { digest?: string } | string }) {
    useEffect(() => {
        if (error) {
            if (logToConsole) {
                //log in the console
                console.error(error);
            }
            //log for tracking
            console.log("Error logged.")
            ErrorLogger_action({
                "currentUrl": `${window.location.href} / ${title}`,
                "stackTrace": ((error instanceof Error) ? error : new Error(error)).stack || ""
            })
        }
    }, [error, title, logToConsole])

    return <section className={ cn("error mx-5 w-fit sm:m-auto bg-black/30 backdrop-blur-sm shadow-xl shadow-black/40 rounded-2xl flex justify-center gap-4 flex-wrap px-2 py-4 text-shadow text-shadow-black/60 text-shadow-x-0 text-shadow-y-[0.35em] text-shadow-blur-[0.2em]", className) }>
        <AnimatedIcon icon="error" className={ cn("text-[clamp(250px,30vmin,80vw)]", small && "text-[clamp(120px,15vmin,40vw)]") } play noHover />
        <div className="inline-flex gap-4 flex-col items-center flex-1 justify-center p-2 sm:pe-16 text-center">
            <h2 role="heading" className={ cn("text-6xl", small && "text-2xl") }>
                <BiErrorAlt style={ { display: "inline" } } />
                { title }
            </h2>
            <div>
                <p className="text-justify [text-align-last:center] max-w-xl text-last text-shadow-y-[0.2em]">
                    { description }
                    { logToConsole && <>
                        <br />
                        ניתן לראות את פרטי השגיאה בקונסול..
                    </> }
                </p>

                { helpReport &&
                    <h4 role="heading" className="mt-4">מה אפשר לעשות?</h4>
                }

                { action && action }
                { helpReport &&
                    <p className="text-justify [text-align-last:center] max-w-xl text-last text-shadow-y-[0.2em]">
                        אשמח לדיווח על הבעייה בדיסקורד.
                    </p>
                }
            </div>
        </div>
    </section >
}